import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../../api/apiClient";
import ENDPOINTS from "../../../api/endPoint";
import {
  createPassword,
  fetchUserInfo,
  initiateForgotPasswordSvs,
  resetUserPassword,
  verifyPasswordResetOtp,
} from "../../../services/authService";
import {
  createApprovalFlow,
  createCustomer,
  Createcustomeraccess,
  createRegisterCustomer,
  Deletecustomeraccess,
  fetchAccountStatement,
  fetchAllCustomerPayments,
  fetchAllCustomers,
  fetchCreditNote,
  fetchCustomerAccess,
  fetchCustomerDashboard,
  fetchCustomerDetails,
  fetchCustomerInvoices,
  fetchCustomerPayment,
  fetchLogisticDetails,
  getAllApprovalStatusesByCustomerId,
  getApprovalCustomerById,
  getAprrovalCustomersByUserId,
  getCreditLineCustomersByUserId,
  getCustomersBySellerId,
  getExistingCustomer,
  sendCredentialAPI,
  Updatecustomeraccess,
  updateCustomerGuaranteeType,
} from "../../../services/customerService";
import { submitFeedbackForm } from "../../../services/feedbackService";
import {
  createPaymentPost,
  getPaymentHistory,
  submitPaymentRequest,
  updateReferenceNumber,
} from "../../../services/paymentService";

export const addCustomer = createAsyncThunk(
  "customer/register",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await createCustomer(formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

// src/app/features/thunks/customerThunks.js
export const updateCustomer = createAsyncThunk(
  "customer/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await apiClient(ENDPOINTS.CUSTOMER_UPDATE(id), {
        method: "PUT",
        body: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const registerCustomer = createAsyncThunk(
  "customer/register",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await createRegisterCustomer(formData);
      return response.data;
    } catch (error) {
      return rejectWithValue({
        message: error.message,
        messageKey: error.messageKey,
      });
    }
  }
);

export const fetchCustomersBySellerId = createAsyncThunk(
  "customer/fetchBySellerId",
  async (sellerId, { rejectWithValue }) => {
    try {
      const response = await getCustomersBySellerId(sellerId);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const fetchAprrovalCustomersByUserId = createAsyncThunk(
  "customer/fetchAprrovalCustomersByUserId",
  async (ID, { rejectWithValue }) => {
    try {
      const response = await getAprrovalCustomersByUserId(ID);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const fetchCreditLineCustomersByUserId = createAsyncThunk(
  "customer/fetchCreditLineCustomersByUserId",
  async (ID, { rejectWithValue }) => {
    try {
      const response = await getCreditLineCustomersByUserId(ID);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

// Thunk for fetching current user info
export const fetchUser = createAsyncThunk(
  "auth/fetchUser",
  async (id, { rejectWithValue }) => {
    try {
      return await fetchUserInfo(id);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk for uploading profile image
export const uploadProfileImage = createAsyncThunk(
  "auth/uploadProfileImage",
  async ({ username, file }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      return await apiClient(ENDPOINTS.PROFILE_IMAGE.UPLOAD(username), {
        method: "POST",
        body: formData,
        suppressToast: true,
      });
    } catch (error) {
      return rejectWithValue(error.message || "Failed to upload profile image");
    }
  }
);

// Thunk for fetching profile image
export const fetchProfileImage = createAsyncThunk(
  "auth/fetchProfileImage",
  async (username, { rejectWithValue }) => {
    try {
      return await apiClient(ENDPOINTS.PROFILE_IMAGE.GET(username), {
        method: "GET",
        suppressToast: true,
      });
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk for deleting profile image
export const deleteProfileImage = createAsyncThunk(
  "auth/deleteProfileImage",
  async (username, { rejectWithValue }) => {
    try {
      return await apiClient(ENDPOINTS.PROFILE_IMAGE.DELETE(username), {
        method: "DELETE",
        suppressToast: true,
      });
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk for fetching existing customer info
export const fetchExistingCustomer = createAsyncThunk(
  "cutomer/fetchExistingCustomer",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getExistingCustomer();
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const submitApprovalFlow = createAsyncThunk(
  "approvalFlow/submit",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await createApprovalFlow(formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const getAllApprovalCustomers = createAsyncThunk(
  "approvalCustomer/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchAllCustomers();
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const fetchApprovalCustomerByid = createAsyncThunk(
  "/ApprovalFlow/approvalstatuses-by-customer-id",
  async (customerId, { rejectWithValue }) => {
    try {
      const response = await getApprovalCustomerById(customerId);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const fetchAllApprovalStatusesByCustomerId = createAsyncThunk(
  "approvalCustomer/fetchAllStatuses",
  async (customerId, { rejectWithValue }) => {
    try {
      const response = await getAllApprovalStatusesByCustomerId(customerId);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const sendCustomerCredentialsThunk = createAsyncThunk(
  "/ApprovalFlow/send-customer-credentials",
  async ({ customerId, accountNumber }, { rejectWithValue }) => {
    try {
      const response = await sendCredentialAPI(customerId, accountNumber);
      return customerId;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const getAccountStatment = createAsyncThunk(
  "/account_statement",
  async (id, { rejectWithValue }) => {
    try {
      const response = await fetchAccountStatement(id);
      return response.d.results || [];
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const getCustomerInvoice = createAsyncThunk(
  "/customer-invoice",
  async (id, { rejectWithValue }) => {
    try {
      const response = await fetchCustomerInvoices(id);
      return (
        response.d.results?.filter((item) =>
          item.FiscalFolio?.startsWith("F")
        ) || []
      );
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const getCreditNote = createAsyncThunk(
  "/credit-note",
  async (id, { rejectWithValue }) => {
    try {
      const response = await fetchCreditNote(id);
      return (
        response.d.results?.filter((item) =>
          item.FiscalFolio?.startsWith("C")
        ) || []
      );
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const getCustomerPayment = createAsyncThunk(
  "/payment-details",
  async (id, { rejectWithValue }) => {
    try {
      const response = await fetchCustomerPayment(id);
      return (
        response?.d?.results?.filter((item) => item.CustDoctype === "DZ" || item.CustDoctype === "UR") || []
      );
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const getAllCustomerPayments = createAsyncThunk(
  "/all-customer-payment-details",
  async (user, { rejectWithValue }) => {
    try {
      const response = await fetchAllCustomerPayments(user?.username);
      return response.d.results || [];
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const getLogisticDetails = createAsyncThunk(
  "/logistic-details",
  async (id, { rejectWithValue }) => {
    try {
      const response = await fetchLogisticDetails(id);
      return response.d.results || [];
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const getCustomerDashbaord = createAsyncThunk(
  "/customer-dashboard",
  async (id, { rejectWithValue }) => {
    try {
      const response = await fetchCustomerDashboard(id);
      return response.d.results[0] || [];
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const submitFeedback = createAsyncThunk(
  "feedback/submit",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await submitFeedbackForm(formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const updateReferenceNumberThunk = createAsyncThunk(
  "customerPayment/updateReferenceNumber",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateReferenceNumber(payload);
      return payload;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const createPaymentPostThunk = createAsyncThunk(
  "payment/post",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await createPaymentPost(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const createPasswordThunk = createAsyncThunk(
  "auth/createPassword",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await createPassword(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const initiateForgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async (email, { rejectWithValue }) => {
    try {
      return await initiateForgotPasswordSvs(email);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const verifyOtp = createAsyncThunk(
  "auth/verifyOtp",
  async ({ username, otp }, { rejectWithValue }) => {
    try {
      return await verifyPasswordResetOtp({ username, otp });
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const resetPasswordFGT = createAsyncThunk(
  "auth/resetPassword",
  async ({ username, newPassword, confirmPassword }, { rejectWithValue }) => {
    try {
      return await resetUserPassword({
        username,
        newPassword,
        confirmPassword,
      });
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateCustomerGuaranteeTypeThunk = createAsyncThunk(
  "customer/updateGuaranteeType",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateCustomerGuaranteeType(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const CreatecustomeraccessThunk = createAsyncThunk(
  "Createcustomeraccess/create",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Createcustomeraccess(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const UpdatecustomeraccessThunk = createAsyncThunk(
  "Updatecustomeraccess/update",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Updatecustomeraccess(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const DeletecustomeraccessThunk = createAsyncThunk(
  "Deletecustomeraccess/delete",
  async (id, { rejectWithValue }) => {
    try {
      const response = await Deletecustomeraccess(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const fetchCustomerAccessAsync = createAsyncThunk(
  "CustomerAccess/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchCustomerAccess();
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const fetchCustomerThunkDetails = createAsyncThunk(
  "Customer/GetCustomerCountDashboard",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchCustomerDetails();
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const submitPaymentThunk = createAsyncThunk(
  "payment/submit",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await submitPaymentRequest(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const getPaymentHistoryThunk = createAsyncThunk(
  "payment/history",
  async (customerId, { rejectWithValue }) => {
     try {
       const response = await getPaymentHistory(customerId);
       return response;
     } catch (error) {
       return rejectWithValue(error.message || "Something went wrong");
     }
  }
);
